//node_modules
import React, { FunctionComponent } from "react";
import { NextSeo, FAQPageJsonLd } from "next-seo";

//helpers
import getImageLoaderAbsoluteSrc from "@adjust/website/libs/helper/getImageLoaderAbsoluteSrc";

//hooks
import useCanonical from "@adjust/src/hooks/useCanonical";

//data
import data from "../questions";

const title = "Frequently Asked Questions - Adjust to the Good Life Travel";
const description = "Questions frequently asked by previous customers!";

const MetaComponent: FunctionComponent = () => {
  const canonical = useCanonical();
  const src = getImageLoaderAbsoluteSrc("/images/0986c3524f41762acb4081d207cd6a2d.png", 1200);

  return (
    <>
      <NextSeo
        title={title}
        description={description}
        canonical={canonical}
        noindex={false}
        nofollow={false}
        openGraph={{
          type: "website",
          siteName: "Adjust to the Good Life Travel",
          url: canonical,
          title: title,
          description: description,
          images: [
            {
              url: src,
            },
          ],
        }}
        twitter={{
          cardType: "summary_large_image",
        }}
      />
      <FAQPageJsonLd
        mainEntity={data.map((faq) => {
          return {
            questionName: faq.question,
            acceptedAnswerText: faq.answer.join(" "),
          };
        })}
      />
    </>
  );
};

export default React.memo(MetaComponent);
